"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EthereumNetwork = void 0;
var EthereumNetwork;
(function (EthereumNetwork) {
    EthereumNetwork[EthereumNetwork["MAINNET"] = 1] = "MAINNET";
    EthereumNetwork[EthereumNetwork["GOERLI"] = 5] = "GOERLI";
    EthereumNetwork[EthereumNetwork["OPTIMISM"] = 10] = "OPTIMISM";
    EthereumNetwork[EthereumNetwork["BSC"] = 56] = "BSC";
    EthereumNetwork[EthereumNetwork["MATIC"] = 137] = "MATIC";
    EthereumNetwork[EthereumNetwork["OPTIMISM_GOERLI"] = 420] = "OPTIMISM_GOERLI";
    EthereumNetwork[EthereumNetwork["BASE"] = 8453] = "BASE";
    EthereumNetwork[EthereumNetwork["ARBITRUM"] = 42161] = "ARBITRUM";
    EthereumNetwork[EthereumNetwork["AVALANCHE_FUJI"] = 43113] = "AVALANCHE_FUJI";
    EthereumNetwork[EthereumNetwork["AVALANCHE"] = 43114] = "AVALANCHE";
    EthereumNetwork[EthereumNetwork["ARBITRUM_GOERLI"] = 421613] = "ARBITRUM_GOERLI";
    EthereumNetwork[EthereumNetwork["MUMBAI"] = 80001] = "MUMBAI";
    EthereumNetwork[EthereumNetwork["BASE_GOERLI"] = 84531] = "BASE_GOERLI";
    EthereumNetwork[EthereumNetwork["SEPOLIA"] = 11155111] = "SEPOLIA";
})(EthereumNetwork = exports.EthereumNetwork || (exports.EthereumNetwork = {}));
